<template>
  <div class="app-content-wrapper">
    <div class="brand-settings-wrapper">
      <div class="settings-wrapper">
        <validation-component ref="validationForm"
                              size="small"
                              :validation-condition="validationCondition">
          <template #customOptions>
            <div>
              <div class="custom-options-title">{{$t('message.checkout.customOptions')}}</div>
              <div class="cancel-btn-box margin-bottom-10">
                <span class="label">{{$t('message.checkout.isDisplayOrderNo')}}</span>
                <el-switch v-model="viewTxnId"></el-switch>
              </div>
              <div class="cancel-btn-box margin-bottom-10">
                <span class="label">{{$t('message.checkout.viewCancelBtn')}}</span>
                <el-switch v-model="viewCancelBtn"></el-switch>
              </div>
              <div class="cancel-btn-box">
                <span class="label">{{$t('message.checkout.viewCountryBtn')}}</span>
                <el-switch v-model="viewCountryBtn"></el-switch>
              </div>
            </div>
          </template>
          <!-- <template #viewCancelBtn>
            <div class="cancel-btn-box">
              <span class="label">{{$t('message.checkout.viewCancelBtn')}}</span>
              <el-switch v-model="viewCancelBtn"></el-switch>
            </div>
          </template>
          <template #viewCountryBtn>
            <div class="cancel-btn-box">
              <span class="label">{{$t('message.checkout.viewCountryBtn')}}</span>
              <el-switch v-model="viewCountryBtn"></el-switch>
            </div>
          </template> -->
        </validation-component>
      </div>
      <div class="demo-wrapper">
        <div style="display: flex;justify-content: flex-end;">
          <div class="tabs">
            <div class="tab phone" :class="{'active': demoDevice === 'phone'}" @click="demoDevice = 'phone'">
              <template v-if="demoDevice === 'phone'">
                <img src="../../../../assets/images/phone.png" />
              </template>
              <template v-else>
                <img src="../../../../assets/images/phone-default.png" />
              </template>
            </div>
            <div class="tab" :class="{'active': demoDevice === 'pc'}" @click="demoDevice = 'pc'">
              <template v-if="demoDevice === 'pc'">
                <img src="../../../../assets/images/pc.png" />
              </template>
              <template v-else>
                <img src="../../../../assets/images/pc-default.png" />
              </template>
            </div>
          </div>
        </div>
        <div class="demo-box">
          <template v-if="demoDevice === 'pc'">
            <div class="pc-demo">
              <img src="../../../../assets/images/checkout-pc.png" />
              <img v-if="logo" class="logo" :src="logo" />
              <span v-else-if="brand" class="brand">{{subCharByLength(brand, 30)}}</span>
              <img v-else class="logo" :src="defaultLogo" />
              <div v-if="viewCountryBtn" class="country-info">
                <span>{{$t('message.checkout.selectCountry')}}</span>
                <i class="el-icon-arrow-down"></i>
              </div>
              <div v-if="viewTxnId" class="order-info">
                <div class="order-title">{{$t('message.checkout.orderNo')}}</div>
                <div class="order-no">xxxxxxxxxxxxxxxx</div>
              </div>
              <div class="button" :style="{'color': btnBackground}" :class="{ origin: !btnBackground, setting: btnBackground}">
                <div class="text">{{$t('message.checkout.pay')}} USD 100.00</div>
                <p v-if="viewCancelBtn" class="cancel" :style="{'color': btnBackground || '#00A2DD'}">{{$t('message.checkout.cancelReturn')}}</p>
              </div>
            </div>
          </template>
          <template v-else-if="demoDevice === 'phone'">
            <div class="phone-demo">
              <img src="../../../../assets/images/checkout-phone.png" />
              <img v-if="logo" class="logo" :src="logo" />
              <span v-else-if="brand" class="brand">{{subCharByLength(brand, 30)}}</span>
              <img v-else class="logo" :src="defaultLogo" />
              <div v-if="viewCountryBtn" class="country-info">
                <span>{{$t('message.checkout.selectCountry')}}</span>
                <i class="el-icon-arrow-down"></i>
              </div>
              <div v-if="viewTxnId" class="order-info">
                <div class="order-title">{{$t('message.checkout.orderNo')}}</div>
                <div class="order-no">xxxxxxxxxxxxxxxx</div>
              </div>
              <div class="btn-box">
                <div class="button" :style="{'color': btnBackground}" :class="{ origin: !btnBackground, setting: btnBackground}">
                  <div class="text">{{$t('message.checkout.pay')}} USD 100.00</div>
                  <p v-if="viewCancelBtn" class="cancel" :style="{'color': btnBackground || '#00A2DD'}">{{$t('message.checkout.cancelReturn')}}</p>
                </div>
              </div>
            </div>
          </template>
      </div>
      </div>
    </div>
    <div style="padding: 9px 20px; text-align: left;">
      <el-button type="primary" size="small" @click="submit">{{ $t('message.tableTitleCommon.saveConfiguration') }}</el-button>
    </div>
  </div>
</template>
<script>
import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';

import { ShowWarningMessage, ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import { REQUIRED } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { subCharByLength } from '@/utils/tools/utils';
import ApplicationService from '@/views/application/api/application-list.service';
import { uploadMaterialUseTemplate } from '@/views/transfer/api/contact';

import { addBrand, getBrandInfo, updateBrand } from '../../api/brand';
import { DISPLAY_ORDERNUM_OPTIONS } from '../../api/options';

export default {
  components: {
    ValidationComponent,
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  data() {
    return {
      id: this.$route.query.id,
      demoDevice: 'pc',
      defaultLogo: require('../../../../assets/images/logo-default.png'),
      logo: '',
      brand: '',
      btnBackground: '',
      appWebisteList: [],
      viewCancelBtn: false,
      viewCountryBtn: true,
      viewTxnId: true,
      validationCondition: [
        {
          key: 'brand',
          name: 'message.checkout.brandName',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          placeholder: this.$t('message.validator.input', { input: this.$t('message.checkout.brandName') }),
          bottomTips: this.$t('message.checkout.topDisplayOrderTips'),
          changeValue: (value) => {
            const v = subCharByLength(value, 30, '');
            this.brand = v;
            this.$refs.validationForm.setItemValue('brand', v);
          },
        },
        {
          key: 'logo',
          name: 'message.checkout.logo',
          type: 'upload_fixed_image',
          defValue: '',
          isShowStar: true,
          uploadRange: [
            {
              isDisplayIcon: true,
              uploadFileList: [],
              fileSize: 500, // 500kb
              fileSizeUnit: 'kb',
              limit: 1,
              isFile: false,
              fileTypeRule: 'image/png,image/jpg',
              fileTypeRuleTips: this.$t('message.supportFileErrorTip', { type: 'png, jpg' }),
              fileLongDisplayTips: this.$t('message.checkout.brandLogoTip'),
              fileChange: (fileList) => {
                if (!fileList || !fileList.length) {
                  this.logo = '';
                }
              },
              fileUploadFunc: async (file) => {
                const loading = this.$loading();
                try {
                  const res = await uploadMaterialUseTemplate(file);
                  this.logo = res;
                  loading.close();
                  return { fileUrl: res };
                } catch (err) {
                  loading.close();
                  throw err;
                }
              },
            },
          ],
        },
        {
          key: 'color',
          name: 'message.checkout.mainColor',
          type: 'color-picker',
          defValue: '',
          placeholder: 'message.checkout.colorSelectTip',
          changeValue: (value) => {
            this.btnBackground = value;
          },
        },
        // {
        //   key: 'viewTxnId',
        //   name: 'message.checkout.isDisplayOrderNo',
        //   type: 'radio',
        //   defValue: true,
        //   options: DISPLAY_ORDERNUM_OPTIONS,
        //   isInternationalization: true,
        //   isShowStar: true,
        // },
        // {
        //   key: 'viewTxnId',
        //   name: '',
        //   type: 'slot',
        //   isShowStar: true,
        // },
        // {
        //   key: 'viewCancelBtn',
        //   name: '',
        //   type: 'slot',
        //   isShowStar: true,
        // },
        // {
        //   key: 'viewCountryBtn',
        //   name: '',
        //   type: 'slot',
        //   isShowStar: true,
        // },
        {
          key: 'customOptions',
          name: '',
          type: 'slot',
          isShowStar: true,
        },
        {
          key: 'appIds',
          name: 'message.checkout.useWebsite',
          type: 'dropdown-select',
          multiple: true,
          description: 'message.checkout.useWebsiteTip',
          defValue: [],
          options: this.appWebisteList,
          isShowStar: true,
          rule: [REQUIRED],
          placeholder: this.$t('message.validator.select', { select: this.$t('message.checkout.useWebsite') }),
        },
      ],
    };
  },
  async created() {
    const loading = Loading.service();
    try {
      // 初始化应用下拉列表
      const res = await ApplicationService.getApplicationList({ size: -1 });
      this.appWebisteList.push({ label: this.$t('message.checkout.allWebsite'), value: 'ALL' });
      res.content.forEach((item) => {
        this.appWebisteList.push({ label: item.appName, value: item.id });
      });
      this.$refs.validationForm.setValidationSelectOptions('appIds', this.appWebisteList);
      // 修改品牌是初始化品牌数据
      if (this.id) {
        const brandinfo = await getBrandInfo({ id: this.id });
        this.$refs.validationForm.setItemValue('brand', brandinfo.brand);
        this.$refs.validationForm.setItemValue('color', brandinfo.color, 'color-picker');
        this.$refs.validationForm.setItemValue('appIds', brandinfo.appIds);
        // this.$refs.validationForm.setItemValue('viewTxnId', `${brandinfo.viewTxnId}` !== 'false'); // 兼容历史数据
        if (brandinfo.logoImage) {
          this.validationCondition[1].uploadRange[0].uploadFileList = [{ url: brandinfo.logoImage }];
          this.logo = brandinfo.logoImage;
        }
        this.btnBackground = brandinfo.color;
        this.viewCancelBtn = !!brandinfo.viewCancelBtn;
        this.viewTxnId = `${brandinfo.viewTxnId}` !== 'false';
        this.viewCountryBtn = `${brandinfo.viewCountryBtn}` !== 'false';
        this.brand = brandinfo.brand;
      }
    } catch (error) {
      console.log('Init Edit Brand Error', error);
    }
    loading.close();
  },
  methods: {
    subCharByLength,
    async submit() {
      this.$refs.validationForm.toFormValid(async (data) => {
        if (data.appIds && data.appIds.length > 1 && data.appIds.includes('ALL')) {
          ShowWarningMessage(this.$t('message.checkout.websiteErrorTip'));
          return;
        }
        if (!this.validationCondition[1].uploadRange[0].uploadFileList.length && !data.brand) {
          ShowWarningMessage(this.$t('message.checkout.logoAndNameEmptyTips'));
          return;
        }
        if (this.validationCondition[1].uploadRange[0].uploadFileList.length > 0) {
          const logoFile = this.validationCondition[1].uploadRange[0].uploadFileList[0];
          data.logoImage = logoFile.url;
        } else {
          data.logoImage = '';
        }
        data.viewCancelBtn = this.viewCancelBtn;
        data.viewTxnId = this.viewTxnId;
        data.viewCountryBtn = this.viewCountryBtn;
        const loading = Loading.service();
        let subMethod = addBrand;
        if (this.id) {
          subMethod = updateBrand;
          data.id = this.id;
        }
        subMethod(data).then(() => {
          loading.close();
          ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
          this.$router.push({
            path: '/checkout/brand',
          });
        }).catch(() => {
          loading.close();
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.app-content-wrapper {
  border: 1px solid $color-default;
  .brand-settings-wrapper {
    display: flex;
    border-bottom: 1px solid $color-default;
    .settings-wrapper {
      border-right: 1px solid $color-default;
      width: 340px;
      padding: 20px;
      ::v-deep .el-upload__tip {
        font-size: 13px;
        line-height: 20px;
        width: 300px;
        text-align: left !important;
      }

      .custom-options-title {
        color: $color-text-primary;
        font-weight: 600;
        line-height: 36px;
        margin-bottom: 10px;
      }

      .cancel-btn-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: $color-text-primary;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;

        .label {
          margin-right: 20px;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
    .demo-wrapper {
      width: 100%;
      background-color: $color-default;
      .tabs {
        display: flex;
        height: 36px;
        box-shadow: 0px 4px 10px 0px rgba(141,141,141,0.3);
        border-radius: 4px 4px 4px 4px;
        background: #FFFFFF;
        width: 100px;
        margin-top: 54px;
        margin-right: 50px;
        .tab {
          width: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img {
            width: 22px;
          }
          &.phone {
            border-right: 1px solid #EBEBEB;
          }
        }
      }
      .demo-box {
        display: flex;
        justify-content: center;
        .pc-demo {
          position: relative;
          text-align: center;
          margin-top: 100px;
          display: inline-block;
          .logo {
            position: absolute;
            left: 47px;
            top: 8px;
            height: 25px;
            width: auto;
          }
          .country-info {
            position: absolute;
            top: 60px;
            left: 47px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 178px;
            height: 22px;
            background-color: #F3F3F3;
            border-radius: 2px;
            font-weight: 500;
            font-size: 8px;
            color: #C1C1C1;
            line-height: 23px;
            padding-left: 4px;
            padding-right: 10px;
            box-sizing: border-box;
            .el-icon-arrow-down {
              font-size: 8px !important;
            }
          }
          .order-info {
            position: absolute;
            top: 127px;
            right: 44px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 281px;
            font-weight: 500;
            font-size: 8px;
            color: #C1C1C1;
            .order-title {
              width: 69px;
              height: 18px;
              background: #F3F3F3;
              border-radius: 2px;
              display: flex;
              align-items: center;
              padding-left: 5px;
              box-sizing: border-box;
            }
            .order-no {
              width: 130px;
              height: 18px;
              background: #F3F3F3;
              border-radius: 2px;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding-right: 5px;
              box-sizing: border-box;
            }
          }
          .brand {
            position: absolute;
            left: 47px;
            top: 14px;
            width: auto;
            font-size: 10px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .button {
            position: absolute;
            left: 47px;
            bottom: 38px;
            height: 26px;
            width: 266px;
            border-radius: 2px 2px 2px 2px;
            font-weight: 600;
            font-size: 10px;
            line-height: 26px;
            background-color: currentColor;
            &.origin {
              background-color: #00A2DD;
              color: #FFF;
            }
            &.setting {
              .text {
                filter: grayscale(1) contrast(999) invert(1);
              }
            }
            .cancel {
              font-size: 10px;
            }
          }
        }
        .phone-demo {
          position: relative;
          text-align: center;
          margin-top: 50px;
          display: inline-block;
          .logo {
            position: absolute;
            left:18px;
            top: 70px;
            max-height: 25px;
            max-width: 160px;
          }
          .country-info {
            position: absolute;
            top: 122px;
            left: 18px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 212px;
            height: 15px;
            background-color: #F3F3F3;
            border-radius: 2px;
            font-weight: 500;
            font-size: 8px;
            color: #C1C1C1;
            line-height: 23px;
            padding-left: 4px;
            padding-right: 10px;
            box-sizing: border-box;
            .el-icon-arrow-down {
              font-size: 8px !important;
            }
          }
          .order-info {
            position: absolute;
            top: 321px;
            right: 18px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 214px;
            font-weight: 500;
            font-size: 8px;
            color: #C1C1C1;
            .order-title {
              width: 58px;
              height: 13px;
              background: #F3F3F3;
              border-radius: 2px;
              display: flex;
              align-items: center;
              padding-left: 5px;
              box-sizing: border-box;
            }
            .order-no {
              width: 127px;
              height: 13px;
              background: #F3F3F3;
              border-radius: 2px;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding-right: 5px;
              box-sizing: border-box;
            }
          }
          .brand {
            position: absolute;
            left:18px;
            top: 75px;
            font-size: 10px;
            max-width: 170px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .btn-box {
            padding: 0 17px;
            position: absolute;
            width: 100%;
            box-sizing: border-box;
            bottom: 80px;
            left: 0;
            .button {
              width: 100%;
              height: 26px;
              border-radius: 2px 2px 2px 2px;
              font-weight: 600;
              font-size: 10px;
              line-height: 26px;
              background-color: currentColor;
              &.origin {
                background-color: #00A2DD;
                color: #FFF;
              }
              &.setting {
                .text {
                  filter: grayscale(1) contrast(999) invert(1);
                }
              }
              .cancel {
                font-size: 10px;
              }
            }
          }
        }
      }
    }
    #validation {
      :deep(.el-upload-list__item) {
        &.is-success {
          width: auto;
          max-width: 320px;
          .file-content {
            width: auto;
            img {
              width: auto;
            }
          }
        }
        &.is-successDone {
          width: auto;
          max-width: 320px;
          .file-content {
            width: auto;
            img {
              width: auto;
            }
          }
        }
      }
      :deep(.upload-fixed-image-wrap) {
        width: 65px;
        height: 112px;
        .el-upload-list--picture-card {
          height: 65px;
          .el-upload-list__item {
            height: 65px;
            .file-content {
              min-width: 65px;
            }
          }
        }
        .el-upload--picture-card {
          height: 65px;
          line-height: 70px;
        }
      }
    }
  }
  :deep(.el-form-item__error) {
    top: 40px;
  }
}
</style>
